export interface AdminNavItem {
  path: string;
  label: string;
}

export const ADMIN_SEARCH_INDEX: AdminNavItem[] = [
  { path: "/admin", label: "Finanzas" },
  { path: "/admin/accounts", label: "Cuentas" },
  { path: "/admin/accounts/new", label: "Nueva cuenta" },
  { path: "/admin/plans", label: "Planes" },
  { path: "/admin/plans/new", label: "Nuevo plan" },
  { path: "/admin/integrations", label: "Integraciones" },
  { path: "/admin/integrations/access", label: "Accesos de integración" },
  { path: "/admin/client_integrations", label: "Integraciones de cliente" },
  { path: "/admin/automations", label: "Automatizaciones" },
  { path: "/admin/automations/new", label: "Nueva automatización" },
  { path: "/admin/workspaces", label: "Workspaces" },
  { path: "/admin/settings", label: "Configuración" },
  { path: "/admin/branding", label: "Marca" },
];

const SEGMENT_LABELS: Record<string, string> = {
  admin: "Inicio",
  accounts: "Cuentas",
  plans: "Planes",
  integrations: "Integraciones",
  client_integrations: "Integraciones de cliente",
  automations: "Automatizaciones",
  workspaces: "Workspaces",
  settings: "Configuración",
  branding: "Marca",
  setups: "Configuraciones",
  access: "Accesos",
  new: "Nuevo",
  dashboard: "Dashboard",
};

export function getBreadcrumbs(pathname: string): AdminNavItem[] {
  const segments = pathname.split("/").filter(Boolean);
  let acc = "";
  return segments.map((segment) => {
    acc += `/${segment}`;
    return { path: acc, label: SEGMENT_LABELS[segment] ?? "Detalle" };
  });
}
